/**
 * Send form height message to parent iframe.
*/
const sendFormHeightMessage = () => {
  setTimeout(() => {
    const formHeight = document.getElementById('marketing-preferences-form') !== null
      ? document.getElementById('marketing-preferences-form').clientHeight
      : '1000';
    window.parent.postMessage('{"iframe_height":"' + formHeight + '"}', '*');
  }, 350);
};

export default sendFormHeightMessage;
